module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Extrabld.5defb4539b9df0673b8766ccbd0e1691.ttf";